import styled from "styled-components";
import { Link } from "react-router-dom";

export const DropDownMenuContainer = styled.li`
    .dropdown-menu{
        padding: 10px 15px;
        min-width: 400px !important;
        max-height: ${props => props.menuMaxWindow ? `${props.menuMaxWindow}px`: '300px'};
        overflow-y: auto;
        background: white !important;
        .dropdown-item{
            padding: 0px !important;
            color: #676767;
        }

        @media screen and (max-width: 768px){
          min-width: 0 !important;
          width: 100% !important;
          max-height: ${props => props.menuMaxWindow ? `${Math.round(((70*props.menuMaxWindow)/100))}px !important`: '300px !important'};

          a.dropdown-item{
            text-align: left !important;
          }
        }

        ::-webkit-scrollbar {
          width: 3px;
          cursor: pointer;
        }
    
        ::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
    
        ::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 10px;
        }
    }
`;

export const HoverUserName = styled.div`
  font-weight: 600;
  :hover {
    color: #27aae1;
    transition-duration: 0.4s;
  }
`;

export const MenuSectionTitle = styled.h4`
  color: #444;
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
  border-top: 1px solid #dbdbdb;
  padding-top: 15px;
`;

export const Divider = styled.div`
  margin-top: 20px;
  height: 1px;
  background-color: #dbdbdb;
  width: 100%;
  margin-bottom: 10px;
`;

export const LinkLogin = styled(Link)`
  color: #02c4fd;
  text-decoration: underline;
`;

export const TenantImageLink = styled.div`
  img#tenant-logo {
    width: auto !important;
    max-width: none !important;
  }
`;

export const ButtonModal = styled.button`
  cursor: pointer;
  color: #000 !important;
  font-weight: bold;
`

export const NotificacaoContainer = styled.div` 
  .notifications-empty {
    text-align: center;
    margin-bottom: 0;
    padding: 10px;
    font-size: 18px;
    font-weight: bold;
  }

  #notifications-navBarSuperior {
    position: absolute;
    z-index: 3;
    right: -60px;
    top: 45px;
    
    @media (max-width: 991px) {
      position: fixed !important;
      right: 0 !important;
      left: 0 !important;
      top: auto !important;
      bottom: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
    }
  }

  .notifications-container {
    width: 500px;
    
    @media (max-width: 991px) {
      width: 100% !important;
      max-width: 100% !important;
      border-radius: 20px 20px 0 0 !important;
    }
  }

  .notifications-header {
    background-color: #fff;
    color: #000;
    padding: 10px 0px;
    border-top-left-radius: 0.3em;
    border-top-right-radius: 0.3em;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .notifications-header h5 {
    margin-bottom: 0;
  }

  .notifications-title {
    font-weight: bold;
    font-size: 18px;
    color: #231f20 !important;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
  }

  .notifications-footer {
    background-color: #fff;
    color: #000;
    justify-content: flex-end;
    display: flex;
    padding: 3px 25px;
    border-bottom-left-radius: 0.3em;
    border-bottom-right-radius: 0.3em;
  }

  .notifications-footer span {
    font-size: 1.2rem;
  }

  .notifications-content {
    background-color: #fff;
    border: 1px rgba(0, 0, 0, 0.1) solid;
    color: #9e9e9e;
  }

  .notifications-content .not-first-child {
    border-top-width: 1px;
    border-top-color: #cdcdcd;
    border-top-style: solid;
  }

  .notifications-content:last-child {
    border-bottom-right-radius: 0.3em;
    border-bottom-left-radius: 0.3em;
  }

  .notifications-content .notification-item {
    display: flex;
    padding: 10px;
  }

  .notifications-content .notification-item:hover {
    background-color: #eee;
  }

  .notifications-content .notification-item:last-child:hover {
    background-color: #eee;
    border-bottom-right-radius: 0.3em;
    border-bottom-left-radius: 0.3em;
  }

  .notifications-content .notification-item .notification-icon {
    margin-left: 10px;
    padding-top: 0px;
  }

  .notifications-content .notification-item .notification-icon i {
    font-size: x-large;
    color: #9e9e9e;
    height: 25px;
    width: 25px;
  }

  .notifications-content .notification-item .notification-description {
    margin-left: 10px;
  }

  .notifications-content .notification-item .notification-description label {
    font-size: 16px;
    margin-bottom: 0px;
    color: #000;
  }

  .notifications-content .notification-item .notification-date {
    justify-content: center;
  }

  .notifications-content .notification-item .notification-date label {
    font-size: 11px;
    text-align: right;
    margin-bottom: 0px;
    color: #9e9e9e;
  }

  span, a, div[role="button"] {
    p {
      margin: 0;
      padding: 0;
      font-size: 14px;
      color: #27aae1 !important;
    }
  }
`;

export const TriangleUp = styled.div`
  width: 0;
  height: 0;
  margin-left: 418px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
`;

export const TurmasDropdownContainer = styled.div`
  .turmas-dropdown {
    max-height: 400px !important;
    overflow-y: auto !important;
    min-width: 350px !important;
    padding: 10px !important;
    background: white !important;
    
    @media screen and (max-width: 768px) {
      min-width: 100% !important;
      max-height: 60vh !important;
    }

    /* Estilização do scrollbar */
    ::-webkit-scrollbar {
      width: 8px;
      cursor: pointer;
    }

    ::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 10px;
      
      &:hover {
        background: #a1a1a1;
      }
    }

    /* Firefox scrollbar */
    scrollbar-width: thin;
    scrollbar-color: #c1c1c1 #f1f1f1;

    .dropdown-item {
      padding: 10px 12px !important;
      cursor: pointer;
      white-space: normal !important;
      word-break: break-word;
      color: #676767 !important;
      transition: background-color 0.2s ease;
      
      &:hover {
        background-color: #f5f5f5 !important;
        color: #27aae1 !important;
      }
    }
  }
`;